import WindshieldReviews from './windshield-reviews.component';

export default {
  Root: WindshieldReviews,
};
